module.exports = __webpack_public_path__ + "static/media/lens_vi.87b7c299.png";